import { SearchService } from "./search.service";
import { Metadata } from "../../../shared/models/metadata.model";
import { isMatch } from "../services.utils";
import { SourceItem } from "../../../shared/models/source-item.model";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";

/***
 * This is the local backend implementation that uses the downloaded metadata to get data.
 */
export class MetadataServiceLocal implements SearchService {
    public getPropertyValueSet = async (
        _site: string,
        request: MetadataRequest,
        propertyName: string,
        isValidity: boolean,
        isSystemProperty: boolean,
    ): Promise<Array<SourceItem>> => {
        const hits: { [key: string]: number } = {};
        if (window._download_metadata) {
            for (let metadata of window._download_metadata) {
                if (isMatch(metadata, request)) {
                    if (isValidity) {
                        for (let value in metadata.validity) {
                            if (value.startsWith(propertyName + ":")) {
                                if (hits[value]) {
                                    hits[value]++;
                                } else {
                                    hits[value] = 1;
                                }
                            }
                        }
                        ;
                    } else if (isSystemProperty) {
                        const untypedmeta = metadata as any;
                        if (untypedmeta[propertyName]) {
                            if (hits[untypedmeta[propertyName].toString()]) {
                                hits[untypedmeta[propertyName].toString()]++;
                            } else {
                                hits[untypedmeta[propertyName].toString()] = 1;
                            }
                        }
                    } else {
                        if (metadata.properties[propertyName]) {
                            for (let value of metadata.properties[propertyName]) {
                                if (hits[value.toString()]) {
                                    hits[value.toString()]++;
                                } else {
                                    hits[value.toString()] = 1;
                                }
                            }
                        }
                    }
                }
            }
        }
        // Convert to source items
        const items: Array<SourceItem> = [];
        for (let key in hits) {
            items.push({
                props: {
                    info: {
                        count: [hits[key]],
                    },
                },
                value: key,
            });
        }
        return items;
    }

    public getPropertyNames = async (
        _site: string,
        request: MetadataRequest,
    ): Promise<Array<SourceItem>> => {
        const nameItems: Array<SourceItem> = [];
        if (window._download_metadata) {
            for (let metadata of window._download_metadata) {
                if (isMatch(metadata, request)) {
                    for (let key in metadata.properties) {
                        if (nameItems.filter((nameItem) => nameItem.value === key).length === 0) {
                            nameItems.push({ value: key, props: {} });
                        }
                    }
                }
            }
        }
        return nameItems;
    }

    public search = async (
        _site: string,
        request: MetadataRequest,
        _refreshCache?: boolean,
        _unpublished?: boolean,
    ): Promise<Array<Metadata>> => {
        const results: Array<Metadata> = [];
        if (window._download_metadata) {
            for (let metadata of window._download_metadata) {
                if (isMatch(metadata, request)) {
                    results.push(metadata);
                }
            }
        }
        return results;
    }

    public searchSimilar = async (
        _site: string,
        _id: string,
        _request: MetadataRequest,
        _refreshCache?: boolean,
    ): Promise<Array<Metadata>> => {
        const results: Array<Metadata> = [];
        return results;
    }


}
